import React from 'react';
import { TextLink } from '@dsg-tech/homefield-react';
import { useAppSelector } from 'store/store';
import {
  storeIdSelector,
  storeNameSelector,
  getFeatureFlagByNameSelector,
} from 'store/selectors/commonSelector';
import { footerTaxoSelector } from 'store/selectors/taxonomySelector';
import useLogger from 'hooks/useLogger';
import FooterColumn from './FooterColumn';
import TopMessages from './TopMessages/TopMessages';
import MiddleSection from './MiddleSection/MiddleSection';
import ErrorBoundaryWithLogger from '../../common/ErrorBoundary/ErrorBoundary';
import FooterLogo from './FooterLogo/FooterLogo';
import FooterLinks from './FooterLinks/FooterLinks';
import MobileAccordion from './MobileAccordion/MobileAccordion';
import './Footer.scss';

const Footer = () => {
  const storeId = useAppSelector(storeIdSelector);
  const taxonomy = useAppSelector(footerTaxoSelector);
  const storeName = useAppSelector(storeNameSelector);
  const headerLogoNetStorageEnabled = useAppSelector(
    getFeatureFlagByNameSelector('headerLogoNetStorageEnabled'),
  );
  const { error } = useLogger();
  const columns =
    taxonomy['Footer Links'] && taxonomy['Footer Links'][0] && taxonomy['Footer Links'][0].csvData;

  try {
    return (
      <div data-testid="footer-links">
        <ErrorBoundaryWithLogger componentId="Footer-TopMessages">
          <TopMessages />
        </ErrorBoundaryWithLogger>
        <ErrorBoundaryWithLogger componentId="Footer-MiddleSection">
          <MiddleSection />
        </ErrorBoundaryWithLogger>
        <ErrorBoundaryWithLogger componentId="Footer-MobileAccordion/FooterColumn">
          <MobileAccordion links={columns} />
          <FooterColumn columns={columns} />
        </ErrorBoundaryWithLogger>

        <div className="footer-bottom-section hmf-display-flex hmf-flex-column hmf-align-items-center hmf-py-l hmf-px-s hmf-px-md-m">
          <div className="footer-bottom-details">
            {headerLogoNetStorageEnabled && (
              <div className="hmf-mb-l">
                <FooterLogo />
              </div>
            )}

            <div
              data-testid="footer-copyright"
              className="hmf-body-s hmf-text-align-center hmf-mb-xs">
              <span>
                &copy; {new Date().getFullYear()} {storeName}
              </span>
            </div>
            <div className="hmf-body-s hmf-mb-m hmf-text-align-center">
              *Price Promotions - Due to manufacturer restrictions, select new release and other
              specified products are excluded from price promotions. Additionally, there are
              restrictions on the use of coupon codes.
            </div>
            <div className="hmf-body-s hmf-mb-m hmf-text-align-center">
              <span data-testid="footer-screen-reader-msg">
                If you are using a screen reader and are having problems using this website, please
                call{' '}
                <TextLink
                  variant="tertiary"
                  size="small"
                  href={storeId === 10701 ? 'tel:800-287-9060' : 'tel:8778469997'}>
                  {storeId === 10701 ? ' 800-287-9060 ' : ' 877-846-9997 '}
                </TextLink>{' '}
                for assistance.
              </span>
            </div>
            <FooterLinks />
          </div>
        </div>
      </div>
    );
  } catch (e) {
    error('Could not load Footer - ', e);
    return null;
  }
};

export default Footer;
